/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmployee = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7zm-.498 10.52C5.48 18.385 5 19.585 5 21v1H3v-1c0-1.9.664-3.7 2.212-5.008C6.739 14.703 9 14 12 14c3 0 5.261.704 6.788 1.992C20.336 17.3 21 19.1 21 21v1h-2v-1c0-1.416-.48-2.616-1.502-3.48C16.453 16.64 14.714 16 12 16c-2.715 0-4.453.639-5.498 1.52zM16 20h-4v-2h4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEmployee as Employee };
